import { RECEIVE_ALL_FEEDBACK, RECEIVE_FEEDBACK } from '../actions/feedback_actions';
var _ = require('lodash')
const feedback_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);

    switch (action.type) {
        case RECEIVE_ALL_FEEDBACK:
            const allFeedback = _.mapKeys(action.allFeedback, "_id")
            let normalizedFeedback = { ...oldState, ...allFeedback }
            return normalizedFeedback
        case RECEIVE_FEEDBACK:
            return Object.assign({}, oldState, {[action.feedback._id]: action.feedback})
        default:
            return oldState;
    }
};

export default feedback_reducer;